import lodash from "lodash";
import { createPage } from "../../../../../utils/page";
import { createLoading } from "../../../../../utils/loading";
import i18n from "../../../../../i18n";
import { createFieldSelect } from "../../../../../components/input/template-builder/template-builder.logic";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { defineAsyncComponent } from "vue";
import store from "../../../../../store";

const ToWhomProductTable = defineAsyncComponent(() => import("./ToWhomProductTable"));
export const { isLoading, setIsLoading } = createLoading();

export const callCountry = ({ searchQuery, country, refObjective }) => {
    return store.dispatch("resource/v1/master/country/cacheFindAll", {
        where: [
            { name: "nameEnS", type: "String", isNot:true, operator: "in", value: refObjective ? [] : country },
            { name: "nameEnS", type: "String", operator: "like", value: searchQuery },
            { logic: 'OR', name: 'nameTh', operator: 'like', value: searchQuery }
            ],
        sort: [{ name: "seq", type: "ASC" }]
    });
}

export const createField = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const refObjective = model.refObjective?.key === '2' && model?.refHazDiscuss?.refResult?.isFact
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refCountry`,
                colProp: () => ({ xs: 24, md: 10 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.freeSale.refCountry"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refCountry,
                            "onUpdate:value": value => {
                                model.refCountry = null
                                model.refInformProduct = null
                                model.refCountry = value
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                            callCountry({
                                searchQuery,
                                country: model.countries,
                                refObjective: refObjective,
                            }),
                            renderLabel: ({ item }) => (
                                <span>
                                    { item.nameEnS } : { item.nameTh }
                                </span>
                            ),
                            optKey: "id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    if(!model?.refCountry){
                        return null
                    }
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}toWhomProducts`,
                            visiblePagination: false,
                            rowKey: refObjective ? 'refInformProduct.id' : 'refHazDiscuss.id',
                            productsKey: refObjective ? 'refInformProduct' : 'refHazDiscuss',
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "ToWhomProductTable" } })
                    );
                    return () => <ToWhomProductTable {...componentProp}></ToWhomProductTable>
                },
            }
        ]
    });
};

export const initData = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.page = createPage({ data: items, options: { sort: [{ name: "approveCode", type: "ASC" }] } });
    data.tableOptions = { search: { activeKey: null } };
    data.manageExtras = [];
    data.rowActions = [];
};
